<template>
  <div
    class="text-count"
    :style="styles"
    @click.stop
    @select.stop
  >
    <div data-test="name">
      {{ name }}<span
        v-if="tooltip"
        v-tooltip="{ content: tooltip }"
        class="pega-circle"
        data-test="tooltip"
      >?</span>
    </div>
    <div
      v-if="max"
      data-test="length"
    >
      {{ textLength }}/{{ max }}文字
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    countTarget: {
      type: String,
      default: ''
    },
    max: {
      type: Number,
      default: 0
    },
    tooltip: {
      type: String,
      default: ''
    },
    margin: {
      type: Number,
      default: null
    }
  },
  computed: {
    textLength () {
      const length = this.countTarget.length
      // 文字列の長さが最大文字数を超えている場合、最大文字数で丸める
      // 理由：BOSS-Sでは入力可能文字数を全角文字を1文字・半角文字を0.5文字として計算しているが、
      //      BOSS-Cに同様のロジックを持ち込みたくない。（1文字ずつ走査して計算している）
      //      その点、typeBOSSも同様の課題を持っていたため、BOSS-C同士の仕様を合わせた。
      return length > this.max ? this.max : length
    },
    styles () {
      if (this.margin > 0) {
        return {
          'margin-top': `calc(${this.margin}px + 0.5rem)`
        }
      } else {
        return {}
      }
    }
  }
}
</script>
